import * as React from "react";

function ArrowRightIcon(props) {
	return (
		<svg viewBox="0 0 24 24" fill="none" width="24" height="24" {...props}>
			<path
				d="M9 6L15 12L9 18"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}

export default ArrowRightIcon;
